import {Button as LibButton, UnstyledButton} from './lib-button';
import {makeClassNameComponentCustom} from 'src/utils/makeClassNameComponent';

import css from './button.css';


export const Button = makeClassNameComponentCustom(css.button, LibButton);
export default Button;

export {UnstyledButton};
